//const selectElement = document.querySelector(".product-form__input--pill");
const selectElement = document.querySelector("variant-selects");

selectElement.addEventListener("click", (event) => {
  
  console.log("hiiii");
  
  var oldVariant = document.getElementsByClassName("axt-cp-custom")[0].id;
  var oldProduct = document
    .getElementsByClassName("axt-cp-custom")[0]
    .getAttribute("axt-cp-product-id");

  setTimeout(() => {
    var variantId = document.querySelector('[name="id"]').value;
    var productId = document.querySelector('[name="product-id"]').value;

    document
      .getElementsByClassName("axt-cp-custom")[0]
      .classList.remove(oldVariant);
    document
      .getElementsByClassName("axt-cp-custom")[0]
      .classList.remove(oldProduct);

    document
      .getElementsByClassName("axt-cp-custom")[0]
      .classList.add(variantId);
    document
      .getElementsByClassName("axt-cp-custom")[0]
      .classList.add(productId);

    document.getElementsByClassName("axt-cp-custom")[0].id = productId;
    document
      .getElementsByClassName("axt-cp-custom")[0]
      .setAttribute("axt-cp-product-id", variantId);
  }, "700");
});
